export const DEFAULT_STORE_TYPE = 'Parrot Communications';

export const STORE_TYPE_SHOPIFY = 'Shopify';

export const STORE_TYPES = [
    {id: STORE_TYPE_SHOPIFY, name: STORE_TYPE_SHOPIFY}
];
